import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ApprovalValetInvoiceLineItems from "./View";
import {getValetItemLineInvoiceId, lineItemsApprovalRejection} from "../../../../../services/redux/sales/postSales/action";

const mapStateToProps = (state) => ({
    lineItemsByInvoiceId: state.postSalesReducer.lineItemsByInvoiceId,
    lineItemsApprovalRejectionResponse: state.postSalesReducer.lineItemsApprovalRejectionResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getValetItemLineInvoiceId,
            lineItemsApprovalRejection
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalValetInvoiceLineItems);
